module.exports = __webpack_public_path__ + "img/BSC.8f6b77f0.png";